 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		18: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"0cb624bafa6477d10b75ad7afee72ee49abc53db","1":"d7edd27c64de57123313ac21323cc304a19241a8","2":"5004e1287700ccb27e8f10f53bf42095ee4c6ebc","3":"1bfc9850","4":"03879f135759568376505b4c297341188301dacd","5":"86b4ae3f17d7247ac4191406b18c186679b8e1a9","6":"19a20990f2af3f85f391ff473195b67ec86a02d5","7":"1b4513541afd8afcd485685db74a64411121f7c3","8":"9efd3cf27b35bfd4c73a38e0488a0417af892c0f","9":"a5bbfc64fa469061f963dfaaf40ecdf64f184b06","10":"176cc7b991f25e234e27c4b8e8e560854f3e32b0","11":"5efe9c7fa6411d9e3ac22c7092be8c5765ad16fc","12":"98ed9885c063b5eb2ee0e8f5cb532e490716f934","13":"styles","14":"37b8bd2ccbfd89460c37392c0c573c7e809c37de","15":"174c994cf21522c571877bb8275d5daf0b2f72f3","16":"4a99c1749c6635d31936a817a6d63ca5dade8896","17":"55eb879a522b4dff6d132af19a901ff48c962d6a","20":"component---src-pages-components-components-jsx","21":"component---src-pages-components-sections-section-basics-jsx","22":"component---src-pages-components-sections-section-carousel-jsx","23":"component---src-pages-components-sections-section-completed-examples-jsx","24":"component---src-pages-components-sections-section-download-jsx","25":"component---src-pages-components-sections-section-examples-jsx","26":"component---src-pages-components-sections-section-javascript-jsx","27":"component---src-pages-components-sections-section-login-jsx","28":"component---src-pages-components-sections-section-navbars-jsx","29":"component---src-pages-components-sections-section-notifications-jsx","30":"component---src-pages-components-sections-section-pills-jsx","31":"component---src-pages-components-sections-section-tabs-jsx","32":"component---src-pages-components-sections-section-typography-jsx","33":"component---src-pages-demo-page-demo-page-jsx","34":"component---src-pages-demo-page-js","35":"component---src-pages-index-js","36":"component---src-pages-landing-page-js","37":"component---src-pages-landing-page-landing-page-jsx","38":"component---src-pages-landing-page-sections-how-it-works-section-jsx","39":"component---src-pages-landing-page-sections-product-section-jsx","40":"component---src-pages-landing-page-sections-team-section-jsx","41":"component---src-pages-landing-page-sections-work-section-jsx","42":"component---src-pages-login-page-login-page-jsx","43":"component---src-pages-profile-page-profile-page-jsx","44":"component---src-pages-team-page-sections-team-contact-section-jsx","45":"component---src-pages-team-page-team-page-jsx"}[chunkId]||chunkId) + "-" + {"0":"8fec435b7df81108ae15","1":"8f25104be6751a554335","2":"14d7f61825727a4ac882","3":"bcf39e5cfd6a18e70c71","4":"91f1189bc68ab10fefb3","5":"e7ed58a9a02ac10e6874","6":"dfd6ae800a560045d3e2","7":"0d013c293eb6c723dbb9","8":"2ea5bffc55ae8f69904e","9":"a7b6c96a6d8193f313ad","10":"1ac5844c90b552884806","11":"c02e04a415135b898590","12":"22555d16679446e47c67","13":"5379f07abcd59a0e64bf","14":"82b9560c9b5114da0399","15":"d10f58753851f180a43d","16":"09e6953b502bbd9d4c5d","17":"4a053a4d04a13ee5d5b5","20":"c05460c5622c05319aaf","21":"c5e38046035ab4d84cf1","22":"5fb9542345f1011bdf15","23":"01fb980173d82620ae44","24":"87a4392d463e3b7d00fa","25":"55a94f6b9056ad958204","26":"29e00e5fd514312d5e62","27":"cb9d629b761c78d81a0a","28":"0c625555728058813206","29":"abaa2f64409bca0e522b","30":"713d1626ca8c739f7eee","31":"97ff103e0ba3639e3ae0","32":"b5785a6a1dc3bc01bef1","33":"807ee080c2d387e20771","34":"a509b33b73d299c96d9d","35":"1df83599305a12de53c9","36":"837b659d75ab29dc0cf2","37":"46a5eb2c309e33f14f79","38":"ffc9f29bb5ce8dc0e46c","39":"0dfec00de362b2dd0d05","40":"6611d8d7bb6d9719f1bf","41":"c078521615156e8bfdfb","42":"8c24b832626dbef6921a","43":"1398cefcaab2a223e107","44":"4c56c02cec06436add32","45":"93250bc680a9fc505606"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"13":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"0cb624bafa6477d10b75ad7afee72ee49abc53db","1":"d7edd27c64de57123313ac21323cc304a19241a8","2":"5004e1287700ccb27e8f10f53bf42095ee4c6ebc","3":"1bfc9850","4":"03879f135759568376505b4c297341188301dacd","5":"86b4ae3f17d7247ac4191406b18c186679b8e1a9","6":"19a20990f2af3f85f391ff473195b67ec86a02d5","7":"1b4513541afd8afcd485685db74a64411121f7c3","8":"9efd3cf27b35bfd4c73a38e0488a0417af892c0f","9":"a5bbfc64fa469061f963dfaaf40ecdf64f184b06","10":"176cc7b991f25e234e27c4b8e8e560854f3e32b0","11":"5efe9c7fa6411d9e3ac22c7092be8c5765ad16fc","12":"98ed9885c063b5eb2ee0e8f5cb532e490716f934","13":"styles","14":"37b8bd2ccbfd89460c37392c0c573c7e809c37de","15":"174c994cf21522c571877bb8275d5daf0b2f72f3","16":"4a99c1749c6635d31936a817a6d63ca5dade8896","17":"55eb879a522b4dff6d132af19a901ff48c962d6a","20":"component---src-pages-components-components-jsx","21":"component---src-pages-components-sections-section-basics-jsx","22":"component---src-pages-components-sections-section-carousel-jsx","23":"component---src-pages-components-sections-section-completed-examples-jsx","24":"component---src-pages-components-sections-section-download-jsx","25":"component---src-pages-components-sections-section-examples-jsx","26":"component---src-pages-components-sections-section-javascript-jsx","27":"component---src-pages-components-sections-section-login-jsx","28":"component---src-pages-components-sections-section-navbars-jsx","29":"component---src-pages-components-sections-section-notifications-jsx","30":"component---src-pages-components-sections-section-pills-jsx","31":"component---src-pages-components-sections-section-tabs-jsx","32":"component---src-pages-components-sections-section-typography-jsx","33":"component---src-pages-demo-page-demo-page-jsx","34":"component---src-pages-demo-page-js","35":"component---src-pages-index-js","36":"component---src-pages-landing-page-js","37":"component---src-pages-landing-page-landing-page-jsx","38":"component---src-pages-landing-page-sections-how-it-works-section-jsx","39":"component---src-pages-landing-page-sections-product-section-jsx","40":"component---src-pages-landing-page-sections-team-section-jsx","41":"component---src-pages-landing-page-sections-work-section-jsx","42":"component---src-pages-login-page-login-page-jsx","43":"component---src-pages-profile-page-profile-page-jsx","44":"component---src-pages-team-page-sections-team-contact-section-jsx","45":"component---src-pages-team-page-team-page-jsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"c962804eb9f12101d308","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
